import React from 'react';
import { graphql } from '@apollo/client/react/hoc';
import gql from 'graphql-tag';
import { Empty, Spin } from 'antd';

import { compose } from '../../../core';
import { getIntFromString } from '../functions';
import { withLookVerticalFilterUpdating, withLookVerticalState } from '../../containers/LookOperations';

import SelectField from './SelectField';

export const VERTICALS_BY_ORG_ID_QUERY = gql`
  query verticals(
    $organization: ID
    $first: Int
    $offset: Int
    $orderBy: [String]
    $name_Icontains: String
    $description_Icontains: String
    $subvertical: [ID]
  ) {
    verticals(
      organization: $organization
      first: $first
      offset: $offset
      orderBy: $orderBy
      name_Icontains: $name_Icontains
      description_Icontains: $description_Icontains
      subvertical: $subvertical
    ) {
      edges {
        node {
          id
          name
          description
          organization {
            id
            name
            description
            email
            logo
          }
        }
      }
    }
        
  }
`;

const SubverticalAutoComplete = props => {
  const { loading, verticals, margin = true, onVerticalNameChange, onAdd, onFiltersRemove } = props;
  const handleFilterRemove = React.useRef(() => { });

  handleFilterRemove.current = () => {
    onFiltersRemove();
  };

  React.useEffect(() => {
    return () => handleFilterRemove.current();
  }, []);

  const choices =
    verticals &&
    verticals.edges.length > 0 &&
    verticals.edges.map(({ node }) => ({
      label: node.organization ? node.organization.name + ' | ' + node.name : node.name || '',
      value: Number(getIntFromString(node.id))
    }));

  return (
    <SelectField
      margin={margin}
      showSearch
      choices={choices}
      onAdd={onAdd}
      newTab={true}
      style={{ width: !margin && 300, marginBottom: !margin && 0 }}
      // labelInValue
      filterOption={false}
      onSearch={onVerticalNameChange}
      notFoundContent={
        loading ? (
          <div align="center">
            <Spin size="small" />
          </div>
        ) : (
          <Empty />
        )
      }
      {...props}
    />
  );
};

export default compose(
  withLookVerticalState,
  graphql(VERTICALS_BY_ORG_ID_QUERY, {
    options: ({ filter, orderBy, pagination, organizationId }) => {
      return {
        variables: {
          ...pagination,
          ...filter,
          organization: organizationId,
          orderBy
        }
      };
    },
    props({ data }) {
      const { loading, error, verticals, subscribeToMore, updateQuery } = data;
      return { loading, error, verticals, subscribeToMore, updateQuery };
    }
  }),
  withLookVerticalFilterUpdating
)(SubverticalAutoComplete);
